if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();
     this.shareButton = this.querySelector('.share-button__toggle');
     this.shareContainer = this.querySelector('.share-button__button');
      this.elements = {
shareButton: this.querySelector('.share-button__toggle')      }

      this.shareButton.addEventListener('click', this.openSocial.bind(this));
    }

    openSocial() {
const isOpen = this.shareContainer.classList.toggle('share-button__button--open');
this.shareButton.setAttribute('aria-expanded', isOpen.toString());    }
  });
}
